import { render, staticRenderFns } from "./queries.view.vue?vue&type=template&id=1718d15e&scoped=true"
import script from "./queries.view.vue?vue&type=script&lang=ts"
export * from "./queries.view.vue?vue&type=script&lang=ts"
import style0 from "./queries.view.vue?vue&type=style&index=0&id=1718d15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1718d15e",
  null
  
)

export default component.exports